export default __webpack_public_path__ + "static/images/logo.6423d97d.png";